<template lang="pug">
div
  .title
    div
    span(class="ht-section-title") {{title}}
    div
//   div(v-if="isDetailGood" @click="switchArea")
//     //-  img(src="@/assets/home.png")
//   div(v-else @click="switchArea")
//     .count {{countInCart}}
//     img(src="@/assets/cart.png")

</template>

<script>
export default {
  data () {
    return {
      title: '登入會員'
    }
  }
}
</script>
<style lang="scss" scoped>
// .count {
//   position: absolute;
//   top: 0;
//   right: 7px;
//   width: 15px;
//   height: 15px;
//   font-size: 12px;
//   line-height: 15px;
//   background: red;
//   color: #f1f2f1;
//   text-align: center;
//   border-radius: 50%;
// }
</style>
